import { render, staticRenderFns } from "./BtoB.vue?vue&type=template&id=b3fd716c&scoped=true&"
import script from "./BtoB.vue?vue&type=script&lang=js&"
export * from "./BtoB.vue?vue&type=script&lang=js&"
import style0 from "./BtoB.vue?vue&type=style&index=0&id=b3fd716c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd716c",
  null
  
)

export default component.exports